export default {
	title: 'Description du projet',
	dateLabel: 'Date de fin d\'autorisation de facturation',
	dateUndefined: 'Non renseignée',
	closeButton: 'J\'ai compris',
	indicatorsInfo: 'Montant total versé ou nombre de patient inclus par rapport au budget alloué au groupement sans prise en compte des indus',
	headers: [
		{
			name: 'alert',
			text: '',
			value: 'alert'
		},{
			name: 'name',
			text: '',
			value: 'name'
		},
		{
			name: 'projectConsumption',
			text: 'Conso projet',
			value: 'projectConsumption'
		}, {
			name: 'groupConsumption',
			text: 'Conso groupement',
			value: 'groupConsumption'
		}, {
			name: 'total',
			text: 'Total alloué',
			value: 'total'
		}
	]
};
